export default ({ hidden=false, onToggle }) => <UI.Icon
  type={ hidden ? 'eye-slash' : 'eye' }
  action={ () => onToggle(!hidden) }
/>;
